export default {"src":"/_next/static/media/pic_05.f3699dc2.JPG","height":4000,"width":6000,"blurWidth":0,"blurHeight":0};